import { render, staticRenderFns } from "./platformBillDetails.vue?vue&type=template&id=33f24dc7"
import script from "./platformBillDetails.vue?vue&type=script&lang=js"
export * from "./platformBillDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports